import BaseService from "./BaseService";
import http from "./HttpService";
import { API_BASE_URL_ENV } from "../jsx/common/common";

const apiEndpoint = API_BASE_URL_ENV() + "/notifications";

export default class NotificationService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}

	send(data) {
		return http.post(`${apiEndpoint}/send`, data);
	}
}
